<template>
    <div id="buyingManagement" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>买货管理</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="购买日期" prop="dateRange" label-width="100px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="任务ID" prop="taskid" label-width="100px">
                    <el-input v-model="queryParams.taskid" clearable placeholder="任务ID" size="small" />
                </el-form-item>

                <el-form-item label="购买账号" prop="payaccount" label-width="100px">
                    <el-input v-model="queryParams.payaccount" clearable placeholder="购买账号" size="small" />
                </el-form-item>

                <el-form-item label="购买人" prop="payuser" label-width="100px">
                    <el-input v-model="queryParams.payuser" clearable placeholder="购买人" size="small" />
                </el-form-item>

                <el-form-item label="购买方式" prop="buytype" label-width="100px">
                    <el-select v-model="buytype" clearable placeholder="购买方式" size="small" multiple>
                        <el-option v-for="item in shopAway" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单编号" prop="ordernumber" label-width="100px">
                    <el-input v-model="queryParams.ordernumber" clearable placeholder="订单编号" size="small" />
                </el-form-item>

                <el-form-item label="状态" prop="status" label-width="100px">
                    <el-select v-model="queryParams.status" clearable placeholder="状态" size="small">
                        <el-option v-for="item in statusData" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <!-- <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">买货</el-button>
                </el-col> -->

                <el-col :span="1.5">
                    <el-button size="mini" @click="returnBuy">退货/退款</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="returnForward">转寄</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="buyEnd">买手结算</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="brandEnd">品牌确认</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="changeHistory">变更历史</el-button>
                </el-col>
            </el-row>

            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="60" fixed="left"></el-table-column>
                <el-table-column label="任务ID" align="left" key="taskid" prop="taskid" />
                <el-table-column label="状态" align="left" width="70">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == '1'">
                            已结算
                        </div>
                        <div v-if="!scope.row.status">
                            未结算
                        </div>
                        <div v-if="scope.row.settlestatus == '1'">
                            已确认
                        </div>
                        <div v-if="!scope.row.settlestatus">
                            未确认
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="购买方式" align="left" key="buytype" prop="buytype" />
                <el-table-column label="购买账号" align="left" key="payaccount" prop="payaccount" />
                <el-table-column label="购买人" align="left" key="payuser" prop="payuser" />
                <el-table-column label="购买人手机号" align="left" key="payuserphone" prop="payuserphone" />
                <!-- <el-table-column label="购买人收件地址" align="left" key="payuseraddress" prop="payuseraddress" /> -->
                <el-table-column label="支付日期" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.paytime }}
                    </template>
                </el-table-column>
                <el-table-column label="支付金额" align="left" key="payprice" prop="payprice" />
                <el-table-column label="买货快递费" align="left" key="expressfee" prop="expressfee" />
                <el-table-column label="运费险" align="left" key="freightinsurance" prop="freightinsurance" />
                <el-table-column label="购买数量" align="left" key="paynum" prop="paynum" />
                <el-table-column label="订单剩余退货/转寄数量" align="left" key="paynumsurplus" prop="paynumsurplus" />
                <el-table-column label="订单编号" align="left" key="ordernumber" prop="ordernumber" />
                <el-table-column label="订单截图" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.orderscreenshot)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.orderscreenshot)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                @click.stop="bigImg(parseScreenshots(scope.row.orderscreenshot)[0])" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="快递单号" align="left" key="couriernumber" prop="couriernumber" />
                <el-table-column label="快递面单" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.expressinvoice)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.expressinvoice)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                v-if="parseScreenshots(scope.row.expressinvoice)[0]"
                                @click.stop="bigImg(parseScreenshots(scope.row.expressinvoice)[0])" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="溯源码图" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.tracediagram)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.tracediagram)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                v-if="parseScreenshots(scope.row.tracediagram)[0]"
                                @click.stop="bigImg(parseScreenshots(scope.row.tracediagram)[0])" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
            </el-table>
            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="dynamicRules" label-width="130px"
                style="height: 500px;overflow: auto;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="任务ID" prop="taskid">
                            <el-select v-model="form.taskid" clearable placeholder="任务ID" style="width: 410px"
                                size="small" @change="selectChange">
                                <el-option v-for="item in taskData" :key="item.taskid" :label="item.taskid"
                                    :value="item.taskid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买账号" prop="payaccount">
                            <el-input v-model="form.payaccount" clearable placeholder="购买账号" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买人" prop="payuser">
                            <el-input v-model="form.payuser" clearable placeholder="购买人" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买人手机号" prop="payuserphone">
                            <el-input v-model="form.payuserphone" clearable placeholder="购买人手机号" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="购买人收件地址" prop="payuseraddress">
                            <el-input v-model="form.payuseraddress" clearable placeholder="购买人收件地址"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24">
                        <el-form-item label="支付日期" prop="paytime">
                            <el-date-picker v-model="form.paytime" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择" style="width: 410px;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="支付金额" prop="payprice">
                            <el-input v-model="form.payprice" clearable placeholder="支付金额" style="width: 410px;"
                                size="small" type="number" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="买货快递费" prop="expressfee">
                            <el-input v-model="form.expressfee" clearable placeholder="买货快递费" style="width: 410px;"
                                size="small" type="number" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="运费险" prop="freightinsurance">
                            <el-input v-model="form.freightinsurance" clearable placeholder="运费险" style="width: 410px;"
                                size="small" type="number" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买数量" prop="paynum">
                            <el-input v-model="form.paynum" clearable placeholder="购买数量" style="width: 410px;"
                                size="small" type="number" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="订单编号" prop="ordernumber">
                            <el-input v-model="form.ordernumber" clearable placeholder="订单编号" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="订单截图" required>
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in orderscreenshot" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index, 'orderscreenshot')"></i>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-show="rulesType == 'rules1'">
                        <el-form-item label="快递单号" prop="couriernumber">
                            <el-input v-model="form.couriernumber" clearable placeholder="快递单号" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-show="rulesType == 'rules1'">
                        <el-form-item label="快递面单" required>
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess2" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload2">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in expressinvoice" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index, 'expressinvoice')"></i>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-show="rulesType == 'rules1'">
                        <el-form-item label="溯源码图" required>
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess3" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload3">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in tracediagram" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index, 'tracediagram')"></i>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买货详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买货详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买货详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买货详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel()">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 图片详情 -->
        <el-dialog title="图片详情" :visible.sync="bigOpen">
            <div style="text-align: center;">
                <img :src="bigurl" style="width: 400px;height: auto;">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bigOpen = false" size="small">取 消</el-button>
            </div>
        </el-dialog>
        <childReturn ref="childReturn" @call-parent-method="parentMethod" type="1" />
        <childForward ref="childForward" @call-parent-method="parentMethod" type="1" />
        <childBuyhand ref="childBuyhand" @call-parent-method="parentMethod" type="1" />
        <childBuyBrand ref="childBuyBrand" @call-parent-method="parentMethod" type="1" />
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import childReturn from "./childReturn";
import childForward from "./childForward";
import childBuyhand from "./childBuyhand";
import childBuyBrand from "./childBuyBrand";

export default {
    name: "buyingManagement",
    components: {
        pagination, childReturn, childForward, childBuyhand, childBuyBrand
    },
    data() {
        return {
            buytype: [],
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                ordernumber: null,
                payuser: null,
                payaccount: null,
                taskid: null,
                buytype: null,
                status: null,
            },
            elUpload: true,
            elUpload2: true,
            elUpload3: true,
            title: '',
            totalNum: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            // 表单参数
            form: {},
            orderscreenshot: [],
            expressinvoice: [],
            tracediagram: [],
            rules1: {
                taskid: [
                    { required: true, message: '请选择任务ID', trigger: 'blur' },
                ],
                payaccount: [
                    { required: true, message: '请填写购买账号', trigger: 'blur' },
                ],
                payuser: [
                    { required: true, message: '请填写购买人', trigger: 'blur' },
                ],
                payuserphone: [
                    { required: true, message: '请填写购买人手机号', trigger: 'blur' },
                ],
                // payuseraddress: [
                //     { required: true, message: '请填写购买人收件地址', trigger: 'blur' },
                // ],
                paytime: [
                    { required: true, message: '请选择支付日期', trigger: 'blur' },
                ],
                payprice: [
                    { required: true, message: '请填写支付金额', trigger: 'blur' },
                ],
                expressfee: [
                    { required: true, message: '请填写买货快递费', trigger: 'blur' },
                ],
                freightinsurance: [
                    { required: true, message: '请填写运费险', trigger: 'blur' },
                ],
                paynum: [
                    { required: true, message: '请填写购买数量', trigger: 'blur' },
                ],
                ordernumber: [
                    { required: true, message: '请填写订单编号', trigger: 'blur' },
                ],
                // orderscreenshot: [
                //     { required: true, message: '请选择订单截图', trigger: 'blur' },
                // ],
                couriernumber: [
                    { required: true, message: '请填写快递单号', trigger: 'blur' },
                ],
                // expressinvoice: [
                //     { required: true, message: '请选择快递面单', trigger: 'blur' },
                // ],
                // tracediagram: [
                //     { required: true, message: '请选择溯源码图', trigger: 'blur' },
                // ],
            },
            rules2: {
                taskid: [
                    { required: true, message: '请选择任务ID', trigger: 'blur' },
                ],
                payaccount: [
                    { required: true, message: '请填写购买账号', trigger: 'blur' },
                ],
                payuser: [
                    { required: true, message: '请填写购买人', trigger: 'blur' },
                ],
                payuserphone: [
                    { required: true, message: '请填写购买人手机号', trigger: 'blur' },
                ],
                // payuseraddress: [
                //     { required: true, message: '请填写购买人收件地址', trigger: 'blur' },
                // ],
                paytime: [
                    { required: true, message: '请选择支付日期', trigger: 'blur' },
                ],
                payprice: [
                    { required: true, message: '请填写支付金额', trigger: 'blur' },
                ],
                expressfee: [
                    { required: true, message: '请填写买货快递费', trigger: 'blur' },
                ],
                freightinsurance: [
                    { required: true, message: '请填写运费险', trigger: 'blur' },
                ],
                paynum: [
                    { required: true, message: '请填写购买数量', trigger: 'blur' },
                ],
                ordernumber: [
                    { required: true, message: '请填写订单编号', trigger: 'blur' },
                ],
                // orderscreenshot: [
                //     { required: true, message: '请选择订单截图', trigger: 'blur' },
                // ]
            },
            open: false,
            taskData: [],
            rulesType: 'rules1',
            dynamicRules: this.rules1,
            returnData: [],
            returnList: [],
            shopAway: [{
                label: 'R买',
                value: 'R买'
            }, {
                label: '购买',
                value: '购买'
            }, {
                label: '溯源',
                value: '溯源'
            }],
            statusData: [{
                label: '未结算',
                value: '0'
            }, {
                label: '未确认',
                value: '1'
            }],
            bigurl: '',
            bigOpen: false,
        };
    },
    watch: {
        // 2根据任务id去判断是否是R买(buytype)，展示不同表单验证规则
        rulesType(newVal) {
            this.dynamicRules = newVal === 'rules1' ? this.rules1 : this.rules2;
        }
    },
    created() {
        this.rulesType = 'rules1'
        if (this.$route.query.taskid) {
            this.orderTask(this.$route.query.taskid)
        }
        this.getList();
    },
    methods: {
        parseScreenshots(screenshotString) {
            return screenshotString.split(',');
        },
        delIcon(index, type) {
            if (type === 'orderscreenshot') {
                this.orderscreenshot.splice(index, 1);
                this.form.orderscreenshot = '';
                this.form.orderscreenshot = this.orderscreenshot.join(',');
            } else if (type === 'expressinvoice') {
                this.expressinvoice.splice(index, 1);
                this.form.expressinvoice = '';
                this.form.expressinvoice = this.expressinvoice.join(',');
            } else {
                this.tracediagram.splice(index, 1);
                this.form.tracediagram = '';
                this.form.tracediagram = this.tracediagram.join(',');
            }
        },
        bigImg(img) {
            this.bigurl = img;
            this.bigOpen = true;
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        parentMethod() {
            this.getList();
        },
        // 选择条数
        handleSelectionChange(val) {
            this.returnData = val
        },
        // 退货
        returnBuy() {
            if (this.returnData.length == 0) {
                this.$message({
                    message: '请选择一条数据',
                    type: 'warning'
                });
                return
            }
            this.returnList = []
            let hasRBuy = false;
            let hasOtherBuyType = false;
            for (let a in this.returnData) {
                if (this.returnData[a].paynumsurplus === 0) {
                    this.$message({
                        message: '任务ID：' + this.returnData[a].taskid + '退货数量0，无法再次退货',
                        type: 'warning'
                    });
                    return
                }
                if (this.returnData[a].buytype === 'R买') {
                    hasRBuy = true;
                } else {
                    hasOtherBuyType = true;
                }
                // 如果同时发现了'R买'和其他购买方式，则显示警告并退出
                if (hasRBuy && hasOtherBuyType) {
                    this.$message({
                        message: 'R买和其他购买方式不能同时存在',
                        type: 'warning'
                    });
                    return;
                }
                this.returnList.push({
                    ordernumber: this.returnData[a].ordernumber,
                    returnNumber: '',
                    refundPrice: '',
                    refundDate: '',
                    refundPriceScreenshot: '',
                    buytype: this.returnData[a].buytype,
                    orderid: this.returnData[a].id,
                    ordertaskid: this.returnData[a].taskid,
                })
            }
            const dataToSend = {
                title: '退货录入',
                form: {
                    returnsublistlist: this.returnList,
                }
            };
            this.$refs.childReturn.updateChange(dataToSend);

        },
        // 转寄
        returnForward() {
            if (this.returnData.length == 0) {
                this.$message({
                    message: '请选择一条数据',
                    type: 'warning'
                });
                return
            }
            this.returnList = []
            for (let a in this.returnData) {
                if (this.returnData[a].buytype === 'R买') {
                    this.$message({
                        message: 'R买不可转寄',
                        type: 'warning'
                    });
                    return
                }
                if (this.returnData[a].paynumsurplus === 0) {
                    this.$message({
                        message: '任务ID：' + this.returnData[a].taskid + '转寄数量0，无法再次转寄',
                        type: 'warning'
                    });
                    return
                }
                this.returnList.push({
                    ordernumber: this.returnData[a].ordernumber,
                    forwardNumber: '',
                    orderid: this.returnData[a].id,
                    ordertaskid: this.returnData[a].taskid,
                })
            }
            const dataToSend = {
                title: '转寄录入',
                form: {
                    forwardidlistList: this.returnList,
                }
            };
            this.$refs.childForward.updateChange(dataToSend);
        },
        buyEnd() {
            if (this.returnData.length == 0) {
                this.$message({
                    message: '请选择一条数据',
                    type: 'warning'
                });
                return
            }
            this.returnList = []
            for (let a in this.returnData) {
                if (this.returnData[a].status == '1') {
                    this.$message({
                        message: '任务ID：' + this.returnData[a].taskid + '已结算，无法再次结算',
                        type: 'warning'
                    });
                    return
                }
                this.returnList.push(this.returnData[a].ordernumber)
                // this.returnList.push({
                //     ordernumber: this.returnData[a].ordernumber,
                //     orderid: this.returnData[a].id,
                //     ordertaskid: this.returnData[a].taskid,
                // })
            }
            const dataToSend = {
                title: '买手结算录入',
                form: {},
                list: this.returnList,
            };
            this.$refs.childBuyhand.updateChange(dataToSend);
        },
        brandEnd() {
            if (this.returnData.length == 0) {
                this.$message({
                    message: '请选择一条数据',
                    type: 'warning'
                });
                return
            }
            this.returnList = []
            for (let a in this.returnData) {
                if (this.returnData[a].settlestatus == '1') {
                    this.$message({
                        message: '任务ID：' + this.returnData[a].taskid + '品牌已确认，无法再次确认',
                        type: 'warning'
                    });
                    return
                }
                this.returnList.push(this.returnData[a].ordernumber)
                // this.returnList.push({
                //     ordernumber: this.returnData[a].ordernumber,
                //     orderid: this.returnData[a].id,
                //     ordertaskid: this.returnData[a].taskid,
                // })
            }
            const dataToSend = {
                title: '品牌确认录入',
                form: {},
                list: this.returnList,

            };
            this.$refs.childBuyBrand.updateChange(dataToSend);
        },
        // 变更历史
        changeHistory() {
            this.$router.push({
                path: '/salesRegistration/buyingHistory',
                query: { modulename: 'GL', name: '买货管理', url: '/salesRegistration/buyingManagement/index' }
            })
        },
        // 1根据任务id去判断是否是R买(buytype)，展示不同表单验证规则
        selectChange(val) {
            let buytype = '';
            for (let a in this.taskData) {
                if (val == this.taskData[a].taskid) {
                    buytype = this.taskData[a].buytype;
                    this.form.ordertaskid = this.taskData[a].id;
                }
            }
            this.updataChange(buytype);
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            this.elUpload = true;
            this.elUpload2 = true;
            this.elUpload3 = true;
            return isLt20M;
        },
        handleUploadSuccess(res) {
            this.orderscreenshot.push(res.data.data);
            this.form.orderscreenshot = ''
            this.form.orderscreenshot = this.orderscreenshot.join(',');
            this.elUpload = false;
        },
        handleUploadSuccess2(res) {
            this.expressinvoice.push(res.data.data);
            this.form.expressinvoice = ''
            this.form.expressinvoice = this.expressinvoice.join(',');
            this.elUpload2 = false;
        },
        handleUploadSuccess3(res) {
            this.tracediagram.push(res.data.data);
            this.form.tracediagram = ''
            this.form.tracediagram = this.tracediagram.join(',');
            console.log(this.tracediagram)
            console.log(this.form.tracediagram)

            this.elUpload3 = false;
        },
        dinji(index) {
            this.dianjiIndex = index;
        },
        handleUploadSuccess5(res) {
            this.returnList[this.dianjiIndex].refundPriceScreenshot = res.data.data;
            this.elUpload5 = false;
        },
        // 获取任务id
        orderTask(taskid) {
            let params = {}
            if (taskid) {
                params.taskid = taskid
            }
            fetch({
                url: "hcm/hcmOrderTask/getOrderTask",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.form = {};
                    this.taskData = result.data;
                    this.title = '买货录入';
                    this.form.taskid = this.$route.query.taskid;
                    this.form.buytype = this.taskData[0].buytype;
                    this.form.ordertaskid = this.taskData[0].id;
                    if (taskid) {
                        this.updataChange(this.taskData[0].buytype);
                    } else {
                        this.open = true;
                    }

                }
            })
        },
        // 更新状态
        updataChange(buytype) {
            if (buytype == 'R买') {
                this.rulesType = 'rules2'
                this.dynamicRules = this.rules2;
            } else {
                this.rulesType = 'rules1'
                this.dynamicRules = this.rules1;
            }
            this.$forceUpdate();
            this.open = true;
        },
        // 展示详情
        taskidFun(data) {
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrdergoods/getOrderdetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.form = {};
                    this.form = result.data.details;
                    this.orderscreenshot = result.data.details.orderscreenshot.split(',');
                    this.expressinvoice = result.data.details.expressinvoice.split(',');
                    this.tracediagram = result.data.details.tracediagram.split(',');
                    this.form.paytime = this.$options.filters.fullTime(result.data.details.paytime);
                    this.title = '买货详情'
                    this.updataChange(this.form.buytype);
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            if (this.buytype.length > 0) {
                this.queryParams.buytype = this.buytype.join(',')
            }
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrdergoods/getListOrder",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        transChange() {

        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrdergoods/hcmOrderdetailsDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '买货管理.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 变更历史
        bankFinancialStatement() {

        },
        // 新增
        handleAdd() {
            this.title = "买货录入";
            // this.open = true;
            this.dynamicRules = this.rules1;
            this.orderTask();
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (!this.form.orderscreenshot) {
                    this.$message.error('请上传订单截图！')
                    return;
                }
                if (this.rulesType == 'rules1') {
                    if (!this.form.expressinvoice) {
                        this.$message.error('请上传快递面单！')
                        return;
                    }
                    if (!this.form.tracediagram) {
                        this.$message.error('请上传溯源码图！')
                        return;
                    }
                }
                if (this.form.paynum == 0) {
                    this.$message.error('购买数量不能为0！')
                    return;
                }

                if (valid) {
                    fetch({
                        url: "hcm/hcmOrdergoods/save",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                            this.getList();
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style scoped>
#buyingManagement {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>